import { Component } from 'react'
import { RouterProps, withRouter } from '../../../../../../insfrastructure/utils/with-router-component'
import { Stepper } from './components/stepper'
import { CompanyData } from './components/company-data'
import { AboutCompany } from './components/about-company';
import { CompanyUserData } from './components/company-user-data';
import { ResumeWithRouter } from './components/resume';
import './styles.sass';

class CompanyForm extends Component<RouterProps> {
  state = {
    selected_step: 1,
    filled_steps: 0,
    steps: {
      company_data: 'Dados da Empresa',
      about_company: 'Sobre a Empresa',
      company_user_data: 'Dados do Responsável',
      resume: 'Confirmação',
    },
    company_data: {
      ie_free: false
    },
    about_company: {},
    company_user_data: {}
  }

  onFillStep = (filled_steps: number, form_name: string, form_data: Record<string, any>) => {
    this.setState({ 
      filled_steps: filled_steps > this.state.filled_steps ? filled_steps : this.state.filled_steps,
      selected_step: filled_steps + 1,
      [form_name]: form_data
    });
    
    window.scrollTo(0, 0);
  }

  onChangeStep = (selected_step: number) => {
    this.setState({ selected_step });
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className='company-sign-up-form'>
        <h3>Dados da Empresa</h3>
        <Stepper
        steps={this.state.steps}
        selectedStep={this.state.selected_step}
        filledSteps={this.state.filled_steps}
        onSelect={(stepIndex) => this.onChangeStep(stepIndex)}
        />
        { this.state.selected_step === 1 && 
        <CompanyData
        form_data={this.state.company_data}
        onSubmit={(company_data) => this.onFillStep(1, 'company_data', company_data)} /> }

        { this.state.selected_step === 2 && 
        <AboutCompany
        form_data={this.state.about_company}
        onSubmit={(about_company) => this.onFillStep(2, 'about_company', about_company)} /> }

        { this.state.selected_step === 3 && 
        <CompanyUserData
        form_data={this.state.company_user_data}
        onSubmit={(company_user_data) => this.onFillStep(3, 'company_user_data', company_user_data)} /> }

        { this.state.selected_step === 4 && 
        <ResumeWithRouter
        company_data={this.state.company_data}
        about_company={this.state.about_company}
        company_user_data={this.state.company_user_data} /> }
      </div>
    )
  }
}

export default withRouter(CompanyForm);